
const AddProductsConfig = {
  // IMPORTANT! -----------------------------------------------------------------
  // All Product Types referenced in this file are referring to
  // the ProductTypeId column in RAHERO.dbo.ProductType and not EETypeId
  // IMPORTANT! -----------------------------------------------------------------

  // ------------------------------ solarPanelProductTypeIds ------------------------------
  solarPanelProductTypeIds: [40, 95],
  // ------------------------------ solarPanelProductTypeIds ------------------------------

  // ------------------------------ solarInverterProductTypeIds ------------------------------
  solarInverterProductTypeIds: [41, 96],
  // ------------------------------ solarInverterProductTypeIds ------------------------------

  // ------------------------------ miniSplitHeatPumpProductTypeId ------------------------------
  miniSplitHeatPumpProductTypeId: 46,
  // ------------------------------ miniSplitHeatPumpProductTypeId ------------------------------

  // ------------------------------ installationDetailsAsFiltersProductTypeIds ------------------------------
  // The products in these product types are set up differently in that you need to supply
  // all product details to resolve to a productid rather than first selecting a manufacturer/brand
  // and then entering installation details
  // FL Windows
  // FL Skylights
  // FL Doors
  // FL Roofing
  installationDetailsAsFiltersProductTypeIds: [91, 92, 93, 94],
  // ------------------------------ installationDetailsAsFiltersProductTypeIds ------------------------------

  // ------------------------------ manufacturerFilterOnlyProductTypeIds ------------------------------
  // These product types will use the Manfucaturer only filter template
  manufacturerFilterOnlyProductTypeIds: [20, 21, 22, 23, 45, 49, 59, 60, 97, 98],
  // ------------------------------ manufacturerFilterOnlyProductTypeIds ------------------------------

  // ------------------------------ quantityEEProductAttributeNameIds ------------------------------
  // new list 02/28/2017
  // DECLARE @listStr VARCHAR(MAX)
  // 		SELECT @listStr = COALESCE(@listStr+',' ,'') + CAST(EEProductAttributeNameId as varchar)
  //    FROM eeproductattributename
  //    where isinputfield = 1 and (Name LIKE '%quantity%' OR Name LIKE '%sq%')
  // SELECT @listStr
  //
  // Adding in this additional query to retrieve some missed attributes - MS 5/16/17
  // DECLARE @listStr VARCHAR(MAX)
  // SELECT @listStr = COALESCE(@listStr+',' ,'') + CAST(EEProductAttributeNameId as varchar)
  //     FROM eeproductattributename
  //     where isinputfield = 1
  // 		and (Name NOT LIKE '%quantity%' AND Name NOT LIKE '%sq%')
  // 		and DisplayName like '%sq%'
  //  SELECT @listStr
  quantityEEProductAttributeNameIds: [363, 367, 370, 401, 419, 420, 421, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 436, 437, 438, 439, 440, 441,
    442, 443, 444, 445, 446, 474, 498, 503, 516, 523, 543, 793, 803, 806, 816, 820, 822, 827, 828, 830, 840, 853, 864, 870, 876,
    881, 887, 893, 899, 906, 910, 918, 923, 925, 940, 951, 957, 966, 971, 1006, 1012, 1022, 1028, 1032, 1040, 1054, 1057, 1060, 1063, 1065],
  // ------------------------------ quantityEEProductAttributeNameIds ------------------------------

  // ------------------------------ sqftProductTypes ------------------------------
  sqftProductTypes: [12, 16, 17, 18, 19, 30, 39, 42, 43, 45, 59, 60, 61, 63, 94, 99, 100, 101],
  // ------------------------------ sqftProductTypes ------------------------------

  // ------------------------------ lnftProductTypes ------------------------------
  lnftProductTypes: [77, 97],
  // ------------------------------ lnftProductTypes ------------------------------

  // ------------------------------ hideQtyFieldProductTypes ------------------------------
  hideQtyFieldProductTypes: [7, 8, 31, 33, 34, 44, 58, 85, 86, 87, 88, 89, 90],
  // ------------------------------ hideQtyFieldProductTypes ------------------------------

  // ------------------------------ hideEditProductTypes ------------------------------
  hideEditInstallDetailsProductTypes: [85, 86, 87, 88, 89, 90],
  // ------------------------------ hideEditProductTypes ------------------------------

  // ------------------------------ progThermostatEEProductAttributeNameIds ------------------------------
  progThermostatEEProductAttributeNameIds: [751, 755, 766, 769, 787],
  // ------------------------------ progThermostatEEProductAttributeNameIds ------------------------------
};

export default AddProductsConfig;



// WEBPACK FOOTER //
// ./src/app/config/constants/AddProductsConfig.constant.js